import React from 'react';
import Icon from '../AppIcon';

const MobileMenuButton = ({ isOpen, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="fixed top-4 left-4 z-50 lg:hidden p-3 rounded-md bg-card shadow-warm-md border border-border transition-smooth hover:bg-muted active:scale-97"
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
      aria-expanded={isOpen}
    >
      <Icon
        name={isOpen ? 'X' : 'Menu'}
        size={24}
        color="var(--color-card-foreground)"
      />
    </button>
  );
};

export default MobileMenuButton;